import { render, staticRenderFns } from "./Step8.vue?vue&type=template&id=35d1bf42&scoped=true&"
import script from "./Step8.vue?vue&type=script&lang=js&"
export * from "./Step8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1bf42",
  null
  
)

export default component.exports